import QuantityGroup from './QuantityGroup';

export default QuantityGroup;
